import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { FavoritePage } from './favorite-page';

@JsonObject
export class PreferencesUtilisateur {
  @JsonProperty(FavoritePage)
  @Optional
  favoritePage: FavoritePage;

  @JsonProperty(Number)
  @Optional
  adresseLivraisonFavorite: number;
}
